import React, { ChangeEvent } from 'react';
import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import { OrderDataProps } from './interface';
import { InputDocument, InputOrder, InputNFDevolution } from './styles';

export const OrderData: React.FC<OrderDataProps> = (props) => {
  const {
    invoice,
    setInvoice,
    order,
    setOrder,
    manualDevolutionInvoiceNumber,
    setManualDevolutionInvoiceNumber,
    protocolCategory,
    ticketReason
  } = props;

  return (
    <Row className="mt-5 flex-md-column">
      <Column className="mt-md-2 mr-md-2">
        <Text className="mb-2 flex-md-100 color-blue-gray" size={12}>
          Nº do Pedido
        </Text>
        <InputOrder
          value={order}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setOrder(e.target.value)}
        />
      </Column>
      <Column className="ml-4 ml-sm-0 mt-md-2">
        <Text className="mb-2 flex-md-100 color-blue-gray" size={12}>
          Nota Fiscal
        </Text>
        <InputDocument
          value={invoice}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setInvoice(e.target.value)}
        />
      </Column>
      {/* FINANCEIRO E COMPENSAÇÃO DE NOTA DE CRÉDITO */}
      {protocolCategory === '3' && ticketReason === '43' &&
        (
          <Column className="ml-4 ml-sm-0 mt-md-2">
            <Text className="mb-2 flex-md-100 color-blue-gray" size={12}>
              Nº Nota Fiscal de Devolução
            </Text>
            <InputNFDevolution
              onChange={(e: any) => setManualDevolutionInvoiceNumber(e.target.value)}
              value={manualDevolutionInvoiceNumber}
            />
          </Column>
        )}
    </Row>
  );
};